import { Component, OnInit , ViewChild  } from '@angular/core';

//   //full-calendar-Plugin
import { FullCalendarComponent } from '@fullcalendar/angular';
import { EventInput } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction'; // for dateClick
import { MainService } from 'src/app/services/main.service';

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss']
})

export class CalendarComponent implements OnInit {
  language = JSON.parse(localStorage.getItem('language'))
  eventsModel: any;
  showModal: boolean;
  title = 'ngularfullcalendarbootstrap';
  name: string;
  date: string;
  FundList: any = [];
  FundCode: any = [];
  FundName: any = [];
  data: any;
  constructor(private _mainService: MainService) {}

  @ViewChild('calendar') calendarComponent: FullCalendarComponent;

  calendarVisible = true;
  calendarPlugins = [dayGridPlugin, interactionPlugin];
  calendarWeekends = true;
  calendarEvents: EventInput[] = [];

  ngOnInit() {
    const dateFrom = new Date;
    const dateTo   = new Date;
    dateTo.setFullYear(dateTo.getFullYear() + 1)
    this._mainService.getFundHoliday('01/01/' + dateFrom.getFullYear(), '31/12/' + dateTo.getFullYear()).subscribe(response => {
        this.data = response;
        this.data.Result.forEach(element => {
              this.FundList.push({ title : element.HDesc , date : this.format_date(element.HSDate), titlendate : element.HDesc + this.format_date(element.HSDate)}); // 01/01/2019
              this.FundCode.push({ title : element.HDesc , date : this.format_date(element.HSDate), fund: element.FundCode });
        });
        this.calendarEvents = this.removeDuplicates(this.FundList, 'title', 'titlendate');
    })
  }

  eventClick(model: any) {
    this.name = model.event.title;
    this.date = model.event.extendedProps.titlendate;
    let result = this.FundCode.filter(obj => {
      return (obj.title === this.name);
    })

    result = result.filter(obj => {
      return (obj.title + obj.date === this.date);
    })

    this.FundName = result;
    this.FundName.forEach(element => {
      this.FundName = this.FundName.filter(function( obj ) {
          return obj.fund !== element.fund;
      });
      this.FundName.push({ title : element.title , date : element.date, fund: element.fund });
    });
    
    $('#Modal').modal('show');
  }

  hide() {
    this.showModal = false;
  }

  format_date(date) {
    const data = date.split('/');
    return data[2] + '-' + data[1] + '-' + data[0];
  }

  removeDuplicates(array, key, date) {
    const lookup = new Set();
    
    return array.filter(obj => !lookup.has(obj[date]) && lookup.add(obj[date]));
  }


  removeDuplicates2(myArr, prop) {
  return myArr.filter((obj, pos, arr) => {
      return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
  });
}

}
